import {createContext} from 'react'

import {ModalContextType} from '../interfaces'

export const ModalContext = createContext<ModalContextType>({
    isSetup: false,
    setModalRegister: () => {
        /* empty */
    },
    modal: {
        getData: () => undefined,
        getOpened: () => false,
        open: () => {
            /* empty */
        },
        close: () => {
            /* empty */
        },
        closeLast: () => undefined,
        clean: () => {
            /* empty */
        },
    },
})
